import { Inject, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Component from 'vue-class-component';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import type { DiscoveryInfo, IResourceModel } from '@/shared/model/briefing-widget.model';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import BriefingService from '@/service/briefing.service';
import { convertToBriefingResourceReq, getHostName, getLinkEmbedYoutube, isScriptLoaded, timeDifference } from '@/util/ds-util';
import { formatParam, formattedDate, formattedDateDocument, subString } from './artical-common';
import NoteDetail from '@/entities/article-detail/detailsNote/note-details.vue';
import { formatDateAgo } from '../../util/date-util';
import moment from 'moment';
import { checkToShow, deepEquals } from '@/util/common-util';
import AskConversation from '@/v2/home/ask-goover/ask-conversation/ask-conversation.vue';
import { URL_S3_POLARIS } from '@/constants';
import { PAGES } from '@/shared/constants/ds-constants';
import { checkIsGuestAccount } from '@/util/guest-util';
import { v4 as uuidv4 } from 'uuid';
import ScrapAgentService from '@/service/scrap-agent.service';

const briefingStore = namespace('briefingStore');

const appStoreState = namespace('appStore');
const SCREEN_WIDTH_TEXT_TO_RIGHT = 1640;

export interface RelatedDocument {
  _id: string;
  title?: string;
  writer?: any[];
  published_at?: string;
  image_uri_thumbnail?: string;
}

interface RelatedPerson {
  connectomeNodeLabel?: string;
  imageSrc?: string;
  social?: any;
}

export const articleDetailInit: DiscoveryInfo = {
  content: '',
  id: '',
  sourceUri: '',
  serviceHtml: '',
  title: '',
  writer: '',
  publishedAt: '',
  objectReport: '',
  typeData: '',
  writers: '',
  mlSummary: '', // Added field
  mlKeyword: '', // Added field
  sourceSummary: '', // Added field
  mlEntitySearch: '', // Added field
  mlEntity: '', // Added field
};
@Component({
  computed: {
    PAGES() {
      return PAGES;
    },
    moment() {
      return moment;
    },
  },
  methods: {
    deepEquals,
    checkToShow,
    getLinkEmbedYoutube,
    getHostName,
    formatDateAgo,
    formattedDate,
    formattedDateDocument,
    subString,
  },
  components: {
    'ask-sub': AskConversation,
    vueCustomScrollbar: vueCustomScrollbar,
    'note-detail': NoteDetail,
  },
})
export default class ArticleDetail extends Vue {
  @appStoreState.Getter
  public isShowDetailArticle!: boolean;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  selectedComponent = '';
  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;

  @briefingStore.Mutation
  public setSelectedResource!: (payload?: any) => void;

  @briefingStore.Mutation
  public updateTotalResources!: (payload: number) => void;

  @briefingStore.Mutation
  public updateAddingResources!: (payload: IResourceModel) => void;

  @briefingStore.Getter
  public getIsHideSelectedResourceItem!: boolean;

  @briefingStore.Mutation
  public setIsHideSelectedResourceItem!: (payload: any) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @appStoreState.Mutation
  public setIsCanShowCreateAgent!: (isCanShowCreateAgent: boolean) => void;

  @briefingStore.Mutation
  public setIsCreateNewBriefingFromChat!: (IsCreateNewBriefingFromChat: boolean) => void;

  @appStoreState.Mutation
  public setShowCreateBriefing!: (isShowCreateBriefing: boolean) => void;

  @briefingStore.Mutation
  public setUpdateResources!: (payload?: any) => void;

  @Inject('scrapAgentService')
  public scrapAgentService!: () => ScrapAgentService;

  @Inject('discoveryService') public discoveryService: () => DiscoveryAndReportService;

  scrollSettings = {
    wheelPropagation: false,
  };

  itemBrp: any = {
    isBookmarked: true,
  };
  isLoading = false;
  articleDetail: DiscoveryInfo = articleDetailInit;
  articleRelatedDocumentPages = {
    currentPage: 1,
    page: 1,
    pageSize: 5,
  };
  articleRelatedPeoplePages = {
    currentPage: 1,
    page: 1,
    pageSize: 5,
  };
  conversationId = '';
  @Ref() contentToPrint!: HTMLDivElement;

  startIndex = 1;
  numberItemPerPage = 5;
  endIndex = this.startIndex + this.numberItemPerPage;
  queryString = window.location.search;
  param = new URLSearchParams(this.queryString).get('ds-id');
  articleRelatedPeople: RelatedPerson[] = [];
  updatingBookmark = false;
  iframeAllowed = false;
  isReadingMode = false;
  polarisAPI = null;
  screenWidth = window.innerWidth;

  articleDetailListDocument: RelatedDocument[] = [];

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  mounted() {
    const hashConversation = window.location.hash;
    this.conversationId = hashConversation.replace('#ask=', '');
    this.articleRelatedDocumentPages = {
      currentPage: 1,
      positionPage: 1,
      pageSize: 5,
    } as any;
    this.articleRelatedPeoplePages = {
      currentPage: 1,
      positionPage: 1,
      pageSize: 5,
    } as any;
    this.getDataDetail(this.getSelectedResource?.docId || this.param);
    // this.isReadingMode = localStorage.getItem('reading-mode') == 'true';
    // this.checkIframeAllowed(this.articleDetail.sourceUri).then(res => {
    //   this.iframeAllowed = res
    //   if (!this.iframeAllowed) {
    //     this.isReadingMode = true;
    //   }
    // });
  }

  created() {
    if (!isScriptLoaded(URL_S3_POLARIS)) {
      const plugin = document.createElement('script');
      plugin.setAttribute('src', URL_S3_POLARIS);
      plugin.async = true;
      plugin.defer = true;
      document.head.appendChild(plugin);
    }
  }

  unmounted() {
    if (this.articleDetail.embeddedUri) {
      URL.revokeObjectURL(this.articleDetail.embeddedUri);
    }
  }

  get isGuest() {
    return checkIsGuestAccount();
  }

  get tooltipPlacement(): string {
    return this.screenWidth <= SCREEN_WIDTH_TEXT_TO_RIGHT ? 'right' : 'left';
  }

  addToNewAgentBriefing() {
    const briefingResource = this.convert2ReferenceResource(this.getSelectedResource, false);
    this.setReferenceDocumentsForNewBriefing([briefingResource]);
    this.setIsCanShowCreateAgent(true);
    this.setIsCreateNewBriefingFromChat(false);
    this.setShowCreateBriefing(true);
  }

  convert2ReferenceResource(document: IResourceModel, isUpdateBriefing: boolean) {
    const briefingResource = convertToBriefingResourceReq(
      document,
      this.$store.getters.userIdentity.id,
      this.$route.name,
      this.$store.getters['briefingStore/getSelectedBriefingPage'],
      undefined,
      this.$i18n.locale,
      this.$store.getters?.userIdentity?.lastName,
      undefined,
      isUpdateBriefing
    );
    briefingResource.search_type = document?.originParentDocDetail?.search_type;
    // @ts-ignore
    briefingResource.mediaType = document?.originParentDocDetail?.media_type;
    if (
      (briefingResource.search_type[0] === 'REPORT' && briefingResource.mediaType[0] === 'REPORT') ||
      document.originParentDocDetail.doc_type === 4
    ) {
      briefingResource.originType = 'REPORT';
    } else {
      briefingResource.originType = 'DISCOVERY';
    }
    briefingResource.parentDocId = document.docId;
    briefingResource.owner_user_key =
      typeof briefingResource.owner_user_key === 'string' ? briefingResource.owner_user_key : briefingResource.owner_user_key[0];
    briefingResource['referenceDocumentIndex'] = 1;

    return briefingResource;
  }

  // @Watch('isReadingMode')
  // onIsReadingModeChange() {
  //   localStorage.setItem('reading-mode', this.isReadingMode + '');
  // }

  getDataDetail(id) {
    console.log(id);
    this.isLoading = false;
    this.discoveryService()
      .getDetailService(id)
      .then(async res => {
        if (res?.data && res?.data?.id) {
          this.articleDetail = res.data;
          console.log(this.articleDetail);
          if (this.articleDetail.mlEntity) {
            this.getRelatedArticle(this.articleDetail.mlEntity);
          }
          if (this.articleDetail.mlEntitySearch) {
            this.getRelatedPeople();
          }
        } else {
          this.articleRelatedDocumentPages = {
            currentPage: 1,
            positionPage: 1,
            pageSize: 5,
          } as any;
          this.articleRelatedPeoplePages = {
            currentPage: 1,
            positionPage: 1,
            pageSize: 5,
          } as any;
          this.articleDetail = articleDetailInit;
          this.articleDetailListDocument = [];
        }
        this.articleDetail = {
          ...this.articleDetail,
          channel: this.getSelectedResource.channel,
          s3FilePath: this.getSelectedResource.other_info?.s3_file_path,
        };
        // console.log(this.articleDetail);

        await this.briefingService()
          .checkIframeAllowed(this.articleDetail.sourceUri)
          .then(res => {
            // console.log('checkIframeAllowed', res.data);
            const xFrameOptions = res?.data['X-Frame-Options'];
            const contentSecurityPolicy = res?.data['Content-Security-Policy'];

            if (this.checkIframeAllowedInHeader(xFrameOptions?.toLowerCase(), contentSecurityPolicy?.toLowerCase(), this.articleDetail)) {
              this.iframeAllowed = true;
              this.isReadingMode = false;
            } else {
              this.iframeAllowed = false;
              this.isReadingMode = true;
            }
          });

        this.isLoading = true;
        this.isLoading = true;

        // const iframe = document.getElementById('test-iframe');
        // iframe.onload = function () {
        //   console.log('Iframe loaded successfully');
        // };
        // iframe.onerror = function () {
        //   console.error('Error loading iframe');
        // };
      });
  }

  @Watch('articleDetail.s3FilePath')
  async onArticleDetailChanged(newValue?: string) {
    if (newValue) {
      if (
        newValue.endsWith('.docx') ||
        newValue.endsWith('.doc') ||
        newValue.endsWith('.ppt') ||
        newValue.endsWith('.pptx') ||
        newValue.endsWith('.xlsx') ||
        newValue.endsWith('.xls') ||
        newValue.endsWith('.csv') ||
        newValue.endsWith('.hwp')
      ) {
        await this.downloadAndViewReportFromS3(this.getSelectedResource.other_info?.s3_file_path);
      }
      if (newValue.endsWith('.pdf') || newValue.endsWith('.txt') || newValue.endsWith('.html')) {
        this.articleDetail.embeddedUri = await this.buildEmbeddedUri(newValue);
      }
    }
  }

  async buildEmbeddedUri(s3FilePath: string) {
    const response = await this.discoveryService().getFile(s3FilePath);
    const contentType = response.headers['content-type'] || 'application/octet-stream';
    const blob = new Blob([response.data], { type: contentType });
    return URL.createObjectURL(blob);
  }

  cleanHtml(inputHtml) {
    // Step 1: Remove all dangerous "HYPERLINK javascript:void(0)" parts
    let cleaned = inputHtml.replace(/HYPERLINK\s+"javascript:void\(0\)"/gi, '');

    // Step 2: Remove all control character entities like &#x13;, &#x14;, &#x15;
    cleaned = cleaned.replace(/&#x[0-9A-F]+;/gi, '');

    // Step 3: Replace multiple &nbsp; with a single space
    cleaned = cleaned.replace(/(&nbsp;)+/gi, ' ');

    // Step 4: Clean up extra spaces
    cleaned = cleaned.replace(/\s+/g, ' ').trim();

    // Step 5: (Optional) Reformat into nice HTML if you want
    return cleaned;
  }

  getRelatedArticle(data) {
    const keywords = ['elon musk', 'tesla', 'Iphone'];
    this.discoveryService()
      .getRelatedArticlesDiscovery(formatParam(data), 1, localStorage.getItem('lang-key'), 100, 'basic', false)
      .then(res => {
        if (res?.data) {
          this.articleDetailListDocument = res?.data?.data;
        }
      });
  }

  getRelatedPeople() {
    this.discoveryService()
      .getRelatedPeopleDiscovery(this.getSelectedResource.docId, this.$store?.getters?.userIdentity.id)
      .then(res => {
        if (res?.data) {
          this.articleRelatedPeople = res.data?.body?.entityLinkingResultList;
        } else {
          this.articleRelatedPeople = [];
        }
      });
  }

  handleClosePopup() {
    this.setSelectedResource({});
    this.setShowDetailArticles(false);
  }

  processDatetime(datetime) {
    return timeDifference(datetime, this);
  }

  async downloadAndViewReportFromS3(s3FilePath: string) {
    const fileName = s3FilePath.split('/').pop();
    const response = await this.discoveryService().getFile(s3FilePath);
    this.initPolaris(response.data, fileName);
  }

  initPolaris(file: any, fileName: any) {
    const containerId = 'weboffice_container';
    // this.removeElementAndInitPolaris();
    const language = localStorage.getItem('currentLanguage');
    const config = {
      documentType: this.getDocumentType(fileName),
      viewMode: 'read',
      locale: language,
      // zoomRatio: 0.8,
    };

    // @ts-ignore
    PolarisWebOffice(containerId, config)
      .then(WebOfficeAPI => {
        const API = WebOfficeAPI[config.documentType];
        this.polarisAPI = API;
        // Open the file in Polaris Web Office
        API.openDocument({
          name: fileName,
          blob: file,
        }).then(() => {
          // console.log('File opened successfully in Polaris Web Office.');
        });
      })
      .catch(error => {
        console.error('Polaris Web Office initialization failed:', error);
      });
  }

  // removeElementAndInitPolaris() {
  //   if (document.getElementById('weboffice_container')) {
  //     document.getElementById('weboffice_container').remove();
  //   }
  //   const newContainer = document.createElement('div');
  //   newContainer.id = 'weboffice_container';
  //   newContainer.style.height = '100%';
  //   const polarisArea = document.getElementById('polaris-area');
  //   polarisArea.appendChild(newContainer);
  // }

  getDocumentType(fileName) {
    if (fileName.endsWith('.docx') || fileName.endsWith('.doc')) return 'word';
    if (fileName.endsWith('.pptx') || fileName.endsWith('.ppt')) return 'slide';
    if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls') || fileName.endsWith('.csv')) return 'sheet';
    if (fileName.endsWith('.hwp')) return 'hwp';
    return 'word';
  }

  social(face, ist, xt, link) {
    if (face != null) {
      return face;
    } else if (ist != null) {
      return ist;
    } else if (xt != null) {
      return xt;
    } else if (link != null) {
      return link;
    } else {
      return null;
    }
  }

  async addToResource() {
    if (checkIsGuestAccount(true)) {
      return;
    }

    // this.setUpdateResources(this.getSelectedResource);
    // this.setSelectedResource({ ...this.getSelectedResource, isBookmarked: !this.getSelectedResource.isBookmarked });
    this.updatingBookmark = true;
    const userKey = this.getSelectedResource.owner_user_key || this.$store.getters?.userIdentity?.id;
    const requestId = uuidv4();
    const {
      title,
      url: path,
      content,
      documentType,
      type,
      originParentDocDetail,
      bpId,
      publishAt,
      owner_user_key,
      _id,
      writer,
    } = this.getSelectedResource;
    const requestBody = [
      {
        requestId,
        title,
        path: path || '',
        description: content,
        content,
        type,
        collector: 'UW',
        userKey: userKey,
        originDate: originParentDocDetail.created_at,
        searchTypes: originParentDocDetail.search_type,
        mediaType: originParentDocDetail.media_type,
        imageUri: [],
        imageUriThumbnail: originParentDocDetail.image_uri_thumbnail,
        collectedQuality: originParentDocDetail.collected_quality,
        favicon: '',
        img: '',
        lang: '',
        liked: 0,
        keyword: '',
        getMlEntity: [],
        getMlEntitySearch: [],
        requestBy: userKey,
        parentDocId: originParentDocDetail.parent_doc_id[0],
        parentDocIds: originParentDocDetail.parent_doc_id,
        forcedClustering: false,
        requestedResourceList: originParentDocDetail.parent_doc_id,
        targetBpId: null,
        titleBriefingPage: '',
        isFeed: true,
        htmlRaw: '',
        publishedAt: publishAt,
        serviceHtml: '',
        ownerUserKey: owner_user_key || userKey,
        sameBriefingPage: false,
        docType: 11,
        isInsideGroup: false,
        isGroup: false,
        originType: 'REPORT',
        otherInfo: null,
        chunkId: '',
        chunkText: '',
        _id: null,
        created_at: originParentDocDetail.created_at,
        writer: [writer || 'Goover'],
        author: writer || 'Goover',
        searchType: originParentDocDetail.search_type[0],
        isBookmarked: true,
      },
    ];
    console.log('requestBody', requestBody);
    const toggleBookmark = !this.getSelectedResource.isBookmarked;
    const requestPromise = toggleBookmark
      ? this.scrapAgentService().saveDefaultScrapAgentByType(userKey, requestBody)
      : this.briefingService().feedUpdateStatus({
          id: _id,
          briefingPageId: bpId,
          parentDocId: originParentDocDetail?.parent_doc_id[0],
          isBookmarked: false,
          isDeleted: false,
          typeDocument: documentType || 'SCRAPE',
        });
    requestPromise
      .then(response => {
        const changedItem = { ...this.getSelectedResource, isBookmarked: toggleBookmark };
        this.setSelectedResource(changedItem);
        this.setUpdateResources(changedItem);
        this.updateTotalResources(toggleBookmark ? 1 : -1);
        this.updateAddingResources({
          ...this.getSelectedResource,
          isBookmarked: toggleBookmark,
          userProfile: {
            userKey: this.$store.getters?.userIdentity?.id,
            lastName: this.$store.getters?.userIdentity?.lastName,
            imageUrl: this.$store.getters?.userIdentity?.imageUrl,
          },
        });
      })
      .finally(() => {
        this.updatingBookmark = false;
      });
  }
  // addToResource() {
  //   this.updatingBookmark = true;
  //   const toggleBookmark = !this.getSelectedResource.isBookmarked;
  //   const requestPromise = toggleBookmark
  //     ? this.briefingService().saveUserResource(Date.now(), 'DISCOVERY', this.getSelectedResource.originParentDocDetail)
  //     : this.briefingService().unSaveUserResource(Date.now(), this.getSelectedResource.docId);
  //   requestPromise
  //     .then(response => {
  //       this.setSelectedResource({ ...this.getSelectedResource, isBookmarked: toggleBookmark });
  //       this.updateAddingResources({
  //         ...this.getSelectedResource,
  //         isBookmarked: toggleBookmark,
  //         userProfile: {
  //           userKey: this.$store.getters?.userIdentity?.id,
  //           lastName: this.$store.getters?.userIdentity?.lastName,
  //           imageUrl: this.$store.getters?.userIdentity?.imageUrl,
  //         },
  //       });
  //       this.updateTotalResources(toggleBookmark ? 1 : -1);
  //     })
  //     .finally(() => {
  //       this.updatingBookmark = false;
  //     });

  //   // }
  // }

  print() {
    const prtHtml = this.contentToPrint.innerHTML;
    let stylesHtml = '';
    // @ts-ignore
    for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
      stylesHtml += node.outerHTML;
    }
    const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
    WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
  }

  @Watch('articleDetailListDocument')
  displayedItemsDocument() {
    const startIndex = (this.articleRelatedDocumentPages.currentPage - 1) * this.articleRelatedDocumentPages.pageSize;
    const endIndex = startIndex + this.articleRelatedDocumentPages.pageSize;
    return this.articleDetailListDocument.slice(startIndex, endIndex);
  }

  @Watch('articleDetailListDocument')
  totalPagesDocument() {
    return Math.ceil(this.articleDetailListDocument.length / this.articleRelatedDocumentPages.pageSize);
  }

  prevPageDocument() {
    if (this.articleRelatedDocumentPages.currentPage > 1) {
      this.articleRelatedDocumentPages.currentPage--;
    }
  }

  nextPageDocument() {
    if (this.articleRelatedDocumentPages.currentPage <= this.totalPagesDocument()) {
      this.articleRelatedDocumentPages.currentPage++;
    }
  }

  handleRelatedDocument(item) {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set('ds-id', item);
    const newUrl = url.toString();
    window.open(newUrl, '_blank');
  }

  @Watch('articleRelatedPeople')
  displayedItemsPeople() {
    const startIndex = (this.articleRelatedPeoplePages.currentPage - 1) * this.articleRelatedPeoplePages.pageSize;
    const endIndex = startIndex + this.articleRelatedPeoplePages.pageSize;
    return this.articleRelatedPeople.slice(startIndex, endIndex);
  }

  @Watch('articleRelatedPeople')
  totalPagesPeople() {
    return Math.ceil(this.articleRelatedPeople.length / this.articleRelatedPeoplePages.pageSize);
  }

  prevPagePeople() {
    if (this.articleRelatedPeoplePages.currentPage > 1) {
      this.articleRelatedPeoplePages.currentPage--;
    }
  }

  nextPagePeople() {
    if (this.articleRelatedPeoplePages.currentPage < this.totalPagesPeople()) {
      this.articleRelatedPeoplePages.currentPage++;
    }
  }

  newWidowOrigin(link) {
    window.open(link);
  }

  callHideFunction() {
    if (this.getIsHideSelectedResourceItem === false) {
      this.setIsHideSelectedResourceItem(!this.getIsHideSelectedResourceItem);
    } else {
      this.setIsHideSelectedResourceItem(true);
    }
  }

  checkToShowGroupButton() {
    // old logic by Thoaihm
    // (this.getSelectedResource.documentType && this.getSelectedResource.documentType.toString() === 'DISCOVERY') ||
    // (this.getSelectedResource.docId &&
    //   ((this.getSelectedResource.docId && this.getSelectedResource.docId.toString().includes('web')) ||
    //     this.getSelectedResource.docId.toString().includes('news') ||
    //     this.getSelectedResource.docId.toString().includes('new') ||
    //     this.getSelectedResource.docId.toString().includes('webs')))

    // new logic
    if (this.getSelectedResource && this.getSelectedResource.docId) {
      return true;
    } else {
      return false;
    }
  }

  checkToShowBookMarkButton() {
    // old logic by thoaihm
    // this.getSelectedResource.originParentDocDetail && !this.getSelectedResource.isGroupChildren

    // new logic
    if (this.getSelectedResource) {
      const tempData = this.getSelectedResource.isGroupChildren;
      if (tempData === undefined || tempData === null) {
        return true;
      }

      return tempData === false;
    }

    return false;
  }

  get isUserNoteOrSocial() {
    console.log(this.articleDetail);
    return (
      this.articleDetail?.typeData?.toString() === '[USERNOTE]' ||
      this.articleDetail?.sourceUri?.includes('https://www.facebook.com') ||
      this.articleDetail?.sourceUri?.includes('x.com')
    );
  }

  // async checkIframeAllowed(sourceUri: string) {
  //   console.log('sourceUri', sourceUri);
  //   try {
  //     const response = await fetch(sourceUri, { method: 'GET', headers: { 'Host': 'dfdfd'}});
  //     console.log('response', response);
  //     // @ts-ignore
  //     for (const entry of response.headers.entries()) {
  //       debugger;
  //       console.log(entry);
  //
  //       if (entry[0].toLowerCase() === 'X-Frame-Options'.toLowerCase()) {
  //         console.log(`X-Frame-Options: ${entry}`);
  //         // return xFrameOptions !== 'DENY' && !xFrameOptions.includes('SAMEORIGIN');
  //       }
  //
  //       if (entry[0].toLowerCase() === 'Content-Security-Policy'.toLowerCase()) {
  //         console.log(`Content-Security-Policy: ${entry}`);
  //         // return !contentSecurityPolicy.includes('frame-ancestors');
  //       }
  //     }
  //
  //     return true; // No restrictions found
  //   } catch (error) {
  //     console.error('Error checking iframe permissions:', error);
  //     return false; // Assume not allowed on error
  //   }
  // }

  checkIframeAllowedInHeader(xFrameOptions, contentSecurityPolicy, articleDetail) {
    if (articleDetail.sourceUri.includes('http://')) {
      return false;
    }

    if (xFrameOptions && (xFrameOptions === 'deny' || xFrameOptions.includes('sameorigin'))) {
      return false;
    }

    if (contentSecurityPolicy && contentSecurityPolicy.includes('frame-ancestors')) {
      return false;
    }

    const channel = articleDetail.channel.toLowerCase();
    return !(channel.includes('mail') || channel.includes('outlook office'));
  }

  onIframeLoad() {
    const iframe = this.$refs.articleIframe as any;
    const doc = iframe.contentDocument || iframe.contentWindow.document;

    if (doc.title.includes('404') || doc.body.innerText.includes('Not Found')) {
      console.warn('Iframe loaded a 404 page.');
      this.isReadingMode = true;
    }
  }

  updateToLocalStorage() {
    console.log('isReadingMode', this.isReadingMode);
    console.log('isReadingMode local ', localStorage.getItem('reading-mode'));
  }
}
